import { takeLatest, put, select } from 'redux-saga/effects';
import { actions as listActions } from '../slices/DriverSettingListSlice';
import { actions } from '../slices/DriverSettingSlice';
import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';
import ModalHandler from 'utils/modal';
import { driverSettingTypeApi } from '../../../api/index';

const getSearchCriteria = (state) => state.driverSettingList.searchCriteria;

function* getDriverSettingList({ payload: { page, limit, filters } }) {
    try {
        const { routeId, ...params } = filters;

        const response = yield NetworkHandler.get(`${config.getUrl('bus_route')}/${routeId}/driver-setting`, {
            params: {
                page: page ? page - 1 : null,
                size: limit,
                ...params,
            },
        });
        yield put({ type: listActions.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: listActions.get_list_failed.type, payload: error });
    }
}

function* createDriverSetting({ payload: { params } }) {
    try {
        const { route_id } = params;
        const response = yield NetworkHandler.put(`${config.getUrl('bus_route')}/${route_id}/driver-setting`, {
            ...params,
        });
        yield put({ type: actions.create_driver_setting_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Thêm thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.create_driver_setting_failed.type, payload: error });
    }
}

function* updateDriverSetting({ payload: { params } }) {
    try {
        const { route_id } = params;
        const response = yield NetworkHandler.put(`${config.getUrl('bus_route')}/${route_id}/driver-setting`, {
            ...params,
        });
        yield put({ type: actions.update_driver_setting_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.update_driver_setting_failed.type, payload: error });
    }
}

function* deleteDriverSetting({ payload: { params } }) {
    try {
        const { route_id, ...params_ } = params;
        const response = yield NetworkHandler.request({
            url: `${config.getUrl('bus_route')}/${route_id}/driver-setting`,
            method: 'delete',
            data: {
                ...params_,
            },
        });
        yield put({ type: actions.delete_driver_setting_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Xoá thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.delete_driver_setting_failed.type, payload: error });
    }
}

function* assignDriverSetting({ payload: { params } }) {
    try {
        const { route_id } = params;
        const response = yield NetworkHandler.post(`${config.getUrl('bus_route')}/${route_id}/driver-setting/trips`, {
            ...params,
        });
        yield put({ type: actions.assign_driver_setting_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Phân công thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.assign_driver_setting_failed.type, payload: error });
    }
}
function* exportDriverSettingType({ payload: { params, callBackFunction } }) {
    try {
        const { exportDriverSettingType } = driverSettingTypeApi;

        const response = yield exportDriverSettingType({ params });
        if (response) {
            NotificationHandler.notifyDownloadBox(response.data);
            yield put({ type: listActions.export_driver_setting_success.type });
            if (callBackFunction) {
                callBackFunction();
            }
        }
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: listActions.export_driver_setting_failed.type, payload: error });
    }
}

function* watchRequestDetail() {
    yield takeLatest(listActions.get_list.type, getDriverSettingList);
    yield takeLatest(actions.create_driver_setting.type, createDriverSetting);
    yield takeLatest(actions.update_driver_setting.type, updateDriverSetting);
    yield takeLatest(actions.delete_driver_setting.type, deleteDriverSetting);
    yield takeLatest(actions.assign_driver_setting.type, assignDriverSetting);
    yield takeLatest(listActions.export_driver_setting.type, exportDriverSettingType);
}

export default watchRequestDetail;
